module.exports = __webpack_public_path__ + "static/img/news_30.0154b1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_30.png
// module id = PMiV
// module chunks = 2